var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-rhizome"},[_c('div',{staticClass:"hero-rhizome__bg"},[_c('RhizomeCloudStatic')],1),_c('div',{staticClass:"hero-rhizome__logo"},[_c('icon',{attrs:{"name":"icon-logo-letter"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }